exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.subOption {\n  font-size: 14px;\n}\n.subOption input::-webkit-input-placeholder {\n  font-size: 14px;\n}\n.label-switch {\n  float: right;\n}\n.no-bullets {\n    list-style-type: none;\n}\n.mt-2 {\n  width: 100%;\n}\n.inputFileButton {\n  float: left;\n}\n.list-block {\n    padding: 0px 0px 0px 0px;\n    margin: auto;\n    width: 100%\n}\n.button-setting {\n  width: 80px;\n}\nul {\n  margin-left: -35px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5194d308","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/settings/CMDirectDebitSettingsPage.vue
// module id = 1590
// module chunks = 2